var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExercising = function SvgExercising(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16.5,
    height: 16.5,
    x: 2.25,
    y: 1.75,
    stroke: "#A5A6FE",
    strokeWidth: 1.5,
    rx: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A5A6FE",
    d: "M6.25 6.75a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A5A6FE",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M7.75 6.75h4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#A5A6FE",
    d: "M6.25 10a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A5A6FE",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M8.15 10h7.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#A5A6FE",
    d: "M6.25 13.25a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A5A6FE",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M8.35 13.25h7"
  })));
};
export default SvgExercising;